var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferentialExpressionAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00ADDC;}\n\t.st1{fill:#662D91;}\n\t.st2{fill:#524FA1;}\n\t.st3{fill:#B72467;}\n\t.st4{fill:#ED1C24;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.3,56v80c0,13.3-10.7,24-24,24H24c-13.3,0-24-10.7-24-24V56c0-13.3,10.7-24,24-24h101.3 C138.6,32,149.3,42.7,149.3,56L149.3,56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.7,296v-80c0-13.3-10.7-24-24-24H205.3c-13.3,0-24,10.7-24,24v80c0,13.3,10.7,24,24,24h101.3 C319.9,320,330.7,309.3,330.7,296z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.7,56v80c0,13.3,10.7,24,24,24H488c13.3,0,24-10.7,24-24V56c0-13.3-10.7-24-24-24H386.7 C373.4,32,362.7,42.7,362.7,56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M330.7,136V56c0-13.3-10.7-24-24-24H205.3c-13.3,0-24,10.7-24,24v80c0,13.3,10.7,24,24,24h101.3 C319.9,160,330.7,149.3,330.7,136z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.3,192H24c-13.3,0-24,10.7-24,24v80c0,13.3,10.7,24,24,24h101.3c13.3,0,24-10.7,24-24v-80 C149.3,202.7,138.6,192,125.3,192L125.3,192z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,376v80c0,13.3,10.7,24,24,24h101.3c13.3,0,24-10.7,24-24v-80c0-13.3-10.7-24-24-24H24 C10.7,352,0,362.7,0,376z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.7,320H488c13.3,0,24-10.7,24-24v-80c0-13.3-10.7-24-24-24H386.7c-13.3,0-24,10.7-24,24v80 C362.7,309.3,373.4,320,386.7,320z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M386.7,480H488c13.3,0,24-10.7,24-24v-80c0-13.3-10.7-24-24-24H386.7c-13.3,0-24,10.7-24,24v80 C362.7,469.3,373.4,480,386.7,480z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181.3,376v80c0,13.3,10.7,24,24,24h101.3c13.3,0,24-10.7,24-24v-80c0-13.3-10.7-24-24-24H205.3 C192.1,352,181.3,362.7,181.3,376z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferentialExpressionAnalysis);
export default __webpack_public_path__ + "static/media/DifferentialExpressionAnalysis.56be8c520565d8780ab7f6de2120e3e6.svg";
export { ForwardRef as ReactComponent };